import { MdCall } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import StyledLink from 'components/typography/StyledLink';
import { ReactComponent as DefaultLogoIcon } from 'images/icons/inspiretec_white_logo.svg';
import { ReactComponent as PhoneIcon } from 'images/icons/phone.svg';
import { ReactComponent as WebIcon } from 'images/icons/website.svg';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';
import ServerRenderContent from './ServerRenderContent';

export default function HeaderBar(props) {
  const {
    customCss,
    brandPhoneNumber,
    openingTimes,
    websiteUrl,
    brandLogo,
    openPhoneDetails,
  } = props;

  let logo;
  if (brandLogo) {
    const logoUrl = `/api/v1.10/content/${encodeURIComponent(brandLogo)}`;
    logo = <img src={logoUrl} alt="logo" className="h-10 mt-4" />;
  } else {
    logo = <DefaultLogoIcon className="h-10 mt-4 contrast-0 xs:filter-none" />;
  }

  const selectedBooking = useSelector((state) => state.ui.selectedBooking);

  return (
    <div className="z-[3] absolute w-full bg-white xs:bg-inherit">
      <div
        className={`${
          customCss ??
          'navigation-container-quote-link header-bar flex p-4 bg-transparent justify-between items-center border-b border-white/[.3] text-white'
        }`}
      >
        <div className="xs:flex gap-2 min-w-[200px] hidden whitespace-nowrap">
          {brandPhoneNumber && (
            <div className="text-xl mt-2">
              <MdCall />
            </div>
          )}
          <div className="">
            {brandPhoneNumber && (
              <p className="text-[22px] font-medium">{brandPhoneNumber}</p>
            )}
            {openingTimes && <ServerRenderContent html={openingTimes} />}
          </div>
        </div>

        <div className="xs:hidden flex order-last">
          <button
            type="button"
            className={`rounded-full w-[50px] h-[50px] border-[${DEFAULT_PRIMARY_COLOUR}] border-2 flex justify-center items-center`}
            onClick={openPhoneDetails}
          >
            <PhoneIcon />
          </button>
          <div
            className={`rounded-full w-[50px] h-[50px] border-[${DEFAULT_PRIMARY_COLOUR}] border-2 flex justify-center items-center ml-2.5`}
          >
            <WebIcon />
          </div>
        </div>

        <div className="w-full flex xs:justify-center">
          <Link
            to={
              websiteUrl ||
              `${ROUTES_SELF_SERVICE.BOOKINGS}/${selectedBooking.id || selectedBooking.reference}`
            }
          >
            {logo}
          </Link>
        </div>

        <div className="min-w-[118px] hidden xs:inline">
          <StyledLink
            url={
              websiteUrl ||
              `${ROUTES_SELF_SERVICE.BOOKINGS}/${selectedBooking.id || selectedBooking.reference}`
            }
            className=""
            display="Visit website"
          />
        </div>
      </div>
    </div>
  );
}
